import { parse, format } from 'url';
import { ScopeEnums } from './enums';
import { service } from '../../../../../config';

export const getUserInfo = () => {
  return Promise.reject('alipay do not support info');
};

export const redirect = ({ appId, scope = 'base', state }) => {
  const url = parse(location.href, true);
  delete url.query.code;
  delete url.query.openid;
  delete url.query.aliid;
  delete url.alicode;

  const callback = parse(service.callback);

  const link = format({
    protocol: 'https:',
    host: 'openauth.alipay.com',
    pathname: '/oauth2/publicAppAuthorize.htm',
    query: {
      app_id: appId,
      scope: ScopeEnums[scope],
      state,
      redirect_uri: format({
        protocol: callback.protocol,
        host: callback.host,
        pathname: '/alipay/authorize',
        query: {
          redirect: format({
            protocol: url.protocol,
            host: url.host,
            pathname: url.pathname,
            query: url.query
          })
        }
      })
    }
  });
  return location.replace(link);
};

export const auth = ({ appId, state, info }) => {
  const url = parse(location.href, true);

  state = state || url.query.state || 'success';

  if (info && url.query.code) {
    return getUserInfo({
      code: url.query.code,
      appId
    });
  } else if (!info && url.query.aliid) {
    return Promise.resolve(url.query.aliid);
  }
  redirect({
    appId,
    state,
    scope: info ? 'info' : 'base'
  });

  return new Promise(() => {
  });
};
